import React, { useEffect, useRef, useState } from "react";
import { Field } from "react-final-form";
import CloseIcon from "@rsuite/icons/Close";
import { useTranslation } from "react-i18next";
import { Button } from "rsuite";
import { UtilityServices } from "../../../core/services/UtilityServices";
import {
  maxUploadSizeInMB,
  messageTypeArr,
} from "../../../core/config/AppConstants";

interface FileUploadProps {
  name: string;
  prevName?: string;
  accept?: string;
  label?: string;
  browseLabel?: string;
  fileUrl?: string;
  file?: any;
  setFile?: Function;
  maxUploadSize?: number;
}

const FileUpload: React.FC<FileUploadProps> = ({
  name,
  prevName = "",
  accept = ".pdf,.doc,.docx,.csv,.xls,.xlsx",
  label = "UPLOAD FILE",
  browseLabel = "BROWSE",
  fileUrl = null,
  file = null,
  setFile = null,
  maxUploadSize = maxUploadSizeInMB,
}) => {
  const [fileName, setFileName] = useState<string>(prevName);
  const { t } = useTranslation();

  const fileUpload = useRef<HTMLInputElement>(null);

  const fileUploadSize = maxUploadSize * 1024 * 1024;

  useEffect(() => {}, []);

  const resetFile = async (e: any) => {
    e.preventDefault();

    if (fileUpload.current && fileUpload.current instanceof HTMLInputElement) {
      setTimeout(() => {
        fileUpload.current.value = "";
      }, 0);
    }

    setFileName("");
    setFile && setFile(null);
  };

  return (
    <>
      <Field name={name}>
        {({ input, meta }) => (
          <div className="flex-item">
            <div
              className="d-flex items-center normal-file align-bottom"
              style={{
                minHeight: "40px",
                display: "flex",
                alignItems: "bottom",
              }}
            >
              <input
                id="file-upload"
                ref={fileUpload}
                {...input}
                type="file"
                accept={accept}
                onChangeCapture={(e: any) => {
                  const file = e.target.files[0];
                  if (file && file.size > fileUploadSize) {
                    UtilityServices.showToaster({
                      message: t("FILE_SIZE_LESS_THAN", {
                        field: t("FILE"),
                        value: maxUploadSize,
                      }),
                      type: messageTypeArr.error,
                    });
                    e.target.value = "";
                    return;
                  }
                  setFile && setFile(file);
                  if (file.size > 0) {
                    setFileName(file.name);
                  } else {
                    setFileName("");
                  }
                }}
                style={{ display: "none" }}
              />
              <label
                className="normal-file-upload-lbl me-2"
                htmlFor="file-upload"
              >
                {!fileName ? t(label) : fileName}
              </label>
              <br />
              {fileName && (
                <Button
                  appearance="link"
                  color="red"
                  onClick={(e: any) => resetFile(e)}
                >
                  <CloseIcon />
                </Button>
              )}
              <Button
                className="normal-file-upload-lbl mb-4"
                appearance="ghost"
                onClick={() => {
                  if (fileUpload.current) {
                    fileUpload.current.click();
                  }
                }}
              >
                {" " + t(browseLabel) + " "}
              </Button>
            </div>
            {meta.error && meta.touched && (
              <span className="error-message">{meta.error}</span>
            )}
          </div>
        )}
      </Field>
    </>
  );
};

export default FileUpload;
